namespace advisorop.components.advisor {
    
    export class InvestmentReportsController{

        $router;
        activeTab: number = 1;
        objectId: string;
        ppLevel: string;
        public loadingActivityDataLadda: boolean = false;
        public loadingHoldingsDataLadda: boolean = false;
        holdingsTableHeading: string = "";
        activitiesTableHeading: string = "";

        // must be passed via AdvisorService 
        selHDItem: any;
        selHDLevel: string;

        // holdings
        dgHoldings: DevExpress.ui.dxDataGridOptions;
        holdingsData: domains.IHoldingsModel;
        asOfDateHoldings: Date;
        holdingsGridInstance: DevExpress.ui.dxDataGrid; 


        // activities
        dgActivities: DevExpress.ui.dxDataGridOptions;
        activitiesData: domains.IActivitiesModel;
        fromDateActivities: Date;
        toDateActivities: Date;

        constructor(private advisorService: services.AdvisorService,
            private advisorPpService: services.AdvisorPpService,
            private generalService: services.GeneralService) {
            this.dgHoldings = {
                export: {
                    enabled: true,
                    fileName: "investmentholdings"
                },
                bindingOptions: {
                    dataSource: "vm.holdingsData.holdings"
                },
                loadPanel: {
                    enabled: true,
                    text: "Loading holdings..."
                },
                onInitialized: (e: any) => {
                    this.holdingsGridInstance = e.component;
                },
                paging: {
                    pageSize: 20,
                    enabled: true
                },
                scrolling: {
                    mode: "infinite",
                    useNative: true
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                noDataText: "No holdings found for this date",
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: 'Search...'
                },
                wordWrapEnabled: true,
                onCellPrepared: (e: any) => {
                    if (e.rowType === "data" && e.columnIndex === 6) {
                        e.cellElement.css('color', (e.value == 0) ? "black" : (e.value < 0) ? "red" : "green");
                    }
                },
                // PP does not supply account ID on holdings (even when querying at HH level...), we can ask them to add this later.
                //onContentReady: (e: any) => {
                //    if (this.ppLevel === "HH") {
                //        e.columnOption("accountId", "visible", true);
                //    } else {
                //        e.columnOption("accountId", "visible", false);
                //    }
                //},
                columns: [
                    //{ dataField: 'accountId', caption: 'Account' }, // PP does not supply account ID on holdings (even when querying at HH level...)
                    { dataField: 'security.name', caption: 'Instrument' },
                    { dataField: 'securityIdentifier', caption: 'Instrument Id' },
                    { dataField: 'units', caption: 'Units', format: { type: "fixedPoint" } },
                    { dataField: 'price', caption: 'Price', format: { type: "fixedPoint", precision: 2 } },
                    { dataField: 'value', caption: 'Value', format: { type: "currency", precision: 2 } },
                    { dataField: 'sumDollarCost', caption: 'Cost', format: { type: "currency", precision: 2 } },
                    { dataField: 'sumUnrealized', caption: 'Unrealized G/L', format: "$#,##0.00;($#,##0.00)" },
                    //{ dataField: 'accruedInterest', caption: 'Accrued', format: "$#,##0.00;($#,##0.00)" },
                    //{ dataField: 'Commission', caption: 'Gain/Loss' },
                    //{ dataField: 'Commission', caption: 'Gain/Loss %' }
                ],
                summary: {
                    totalItems: [{
                            column: "value",
                            summaryType: "sum",
                            valueFormat: "$#,##0.00"
                    }, {
                            column: "sumDollarCost",
                            summaryType: "sum",
                            valueFormat: "$#,##0.00"
                    }, {
                            column: "sumUnrealized",
                            summaryType: "sum",
                            valueFormat: "$#,##0.00;($#,##0.00)"
                        }
                    ]
                }
            };
            this.dgActivities = {
                export: {
                    enabled: true,
                    fileName: "investmentactivity"
                },
                bindingOptions: {
                    dataSource: "vm.activitiesData.activities"
                },
                //height: "350px",
                paging: {
                    pageSize: 20,
                    enabled: true
                },
                scrolling: {
                    mode: "infinite",
                    useNative: true
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                noDataText: "There is no activity in the date range",
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: 'Search...'
                },
                wordWrapEnabled: true,
                onContentReady: (e: any) => {
                    //console.log("PPLEVEL--->",this.ppLevel)
                    if (this.ppLevel === "CG") {
                        e.component.columnOption("accountId", "visible", false);
                    } else {
                        e.component.columnOption("accountId", "visible", true);
                    }
                },
                columns: [
                    { dataField: 'tradeDate', caption: 'Trade Date', dataType: 'date', format: 'shortDate' },
                    { dataField: 'accountId', caption: 'Account' },
                    { dataField: 'tradeType', caption: 'Activity Type' },
                    { dataField: 'security.name', caption: 'Instrument' },
                    { dataField: 'securityIdentifier', caption: 'Instrument Id' },
                    { dataField: 'units', caption: 'Units', format: { type: "fixedPoint" } },
                    { dataField: 'amount', caption: 'Amount', format: { type: "currency", precision: 2 } },
                    //{ dataField: 'commission', caption: 'Accrued', format: { type: "currency", precision: 2 } },
                ]
            };
        }

        //fmtDate(d: Date) {
        //    return d.getMonth()+1 + "/" + d.getDate() + "/" + d.getFullYear();
        //}

        loadActivityData() {
            if (this.fromDateActivities == null || this.fromDateActivities == undefined || this.toDateActivities == null || this.toDateActivities == undefined) {
                toastr.error("Date can not be blank.");
                return;
            }
            //console.log(`Loading activity data...`);
            this.loadingActivityDataLadda = true;
            var fromMonth = this.fromDateActivities.getMonth();
            var fromDate = this.fromDateActivities.getDate();
            var fromYear = this.fromDateActivities.getFullYear();
            var utcFromDate: Date = new Date(Date.UTC(fromYear, fromMonth, fromDate));
            var toMonth = this.toDateActivities.getMonth();
            var toDate = this.toDateActivities.getDate();
            var toYear = this.toDateActivities.getFullYear();
            var utcToDate: Date = new Date(Date.UTC(toYear, toMonth, toDate));
            //console.log("ToMonth", toMonth);
            //console.log("ToDate", toDate);
            //console.log("ToYear", toYear);
            try {
                this.advisorPpService
                    .requestActivities({
                        ppLevel: this.ppLevel,
                        ppClientId: this.objectId,
                        fromDate: utcFromDate,
                        toDate: utcToDate,
                    })
                    .then(data => {
                        //console.log(`Data received...`);
                        this.activitiesData = data.data;
                        var utcFromDateStr = (fromMonth+1).toString() + "/" + fromDate.toString() + "/" + fromYear.toString();
                        var utcToDateStr = (toMonth+1).toString() + "/" + toDate.toString() + "/" + toYear.toString();
                        this.activitiesTableHeading = "Activity For " + utcFromDateStr + " to " + utcToDateStr + ":"
                    }, err => {
                        this.generalService.showError(err);
                        this.activitiesTableHeading = "";
                    });
               
            } finally {
                this.loadingActivityDataLadda = false;
            }
        }
        
        loadHoldingsData() {
            if (this.asOfDateHoldings == null || this.asOfDateHoldings == undefined) {
                toastr.error("Date can not be blank.");
                return;
            }
            //console.log(`Loading holdings data...`);
            this.loadingHoldingsDataLadda = true;
            var dateMonth = this.asOfDateHoldings.getMonth();
            var dateDate = this.asOfDateHoldings.getDate();
            var dateYear = this.asOfDateHoldings.getFullYear();
            var utcAsofDate: Date = new Date(Date.UTC(dateYear, dateMonth, dateDate));
            try {
                // Show the grid loading panel
                if (this.holdingsGridInstance) {
                    this.holdingsGridInstance.beginCustomLoading("Loading holdings...");
                }

                this.advisorPpService
                    .requestHoldings({
                        ppLevel: this.ppLevel,
                        ppClientId: this.objectId,
                        asOfDate: utcAsofDate,
                        includeLots: true
                    })
                    .then(data => {
                        this.holdingsData = data.data;
                        //console.log("RET:", this.holdingsData);
                        var asofDateStr = (dateMonth+1).toString() + "/" + dateDate.toString() + "/" + dateYear.toString();
                        this.holdingsTableHeading = "Holdings For " + asofDateStr + ":";
                    }, err => {
                        this.generalService.showError(err);
                        this.holdingsTableHeading = "";
                    })
                    .finally(() => {
                        this.loadingHoldingsDataLadda = false;

                        // Hide the grid loading panel
                        if (this.holdingsGridInstance) {
                            this.holdingsGridInstance.endCustomLoading();
                        }
                    });
            } catch (e) {
                console.log(e);
            }
        }
        $onInit(): void {
            // data from today
            this.asOfDateHoldings = new Date();
            this.asOfDateHoldings.setDate(this.asOfDateHoldings.getDate() - 0);

            // default period, last two weeks
            this.fromDateActivities = new Date();
            this.fromDateActivities.setDate(this.fromDateActivities.getDate() - 14);
            this.toDateActivities = new Date();

            // console.log(`Shared HDItem:`, this.advisorService.selHDItem);
            this.selHDItem = this.advisorService.selHDItem;
            this.selHDLevel = this.advisorService.selHDLevel;

            // test data 
            //this.holdingsData = {
            //    "asOfDate": new Date(),
            //    "holdings": [
            //        {
            //            "security": {
            //                "ticker": "SAMPLETCKR1",
            //                "usCode": "",
            //                "name": "Sample Security Name 1",
            //                "type": "mf"
            //            },
            //            "value": 75.0,
            //            "units": 20.0,
            //            "price": 3.75,
            //            "accruedInterest": 1.0,
            //            "lots": null
            //        },
            //        {
            //            "security": {
            //                "ticker": "",
            //                "usCode": "SMPL2",
            //                "name": "Sample Security Name 2",
            //                "type": "an"
            //            },
            //            "value": 100.0,
            //            "units": 10.0,
            //            "price": 10.0,
            //            "accruedInterest": 10.0,
            //            "lots": null
            //        }
            //    ]
            //};

            //this.activitiesData = {
            //    "asOfDate": new Date(),
            //    "exceedsMaxRecords": false,
            //    "activities": [
            //        {
            //            "tradeType": "Sell",
            //            "security": {
            //                "ticker": "SAMPLETCKR1",
            //                "usCode": "",
            //                "name": "Sample Security Name 1",
            //                "type": "mf"
            //            },
            //            "amount": 200.0,
            //            "units": 20.0,
            //            "accountId": "1234567",
            //            "tradeDate": new Date(),
            //            "settlementDate": new Date(),
            //            "commission": 1.0, // per pp doc it was Commissions  (s at the end)
            //            "fees": 2.0,
            //            "secFee": 3.0,
            //            "withTax": 4.0
            //        },
            //        {
            //            "tradeType": "Buy",
            //            "security": {
            //                "ticker": "",
            //                "usCode": "SMPL2",
            //                "name": "Sample Security Name 2",
            //                "type": "an"
            //            },
            //            "amount": 100.0,
            //            "units": 10.0,
            //            "accountId": "9876543",
            //            "tradeDate": new Date(),
            //            "settlementDate": new Date(),
            //            "commission": 2.0,
            //            "fees": 3.0,
            //            "secFee": 2.0,
            //            "withTax": 1.0
            //        }
            //    ]
            //};
        }

        $routerOnActivate(next, previous) {
            if (next.params.id) {
                this.objectId = next.params.id;
            }

            if (next.params.ppLevel) {
                this.ppLevel = next.params.ppLevel;
            }

            if (next.params.tabId) {
                this.activeTab = next.params.tabId;
            }

            if (this.objectId) {
                if (this.activeTab == 1) setTimeout(() => this.loadHoldingsData(), 50);
                if (this.activeTab == 2) setTimeout(() => this.loadActivityData(), 50);
            }
        }
    }


    class InvestmentReports implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "$router": "<",
            };
            this.controller = ["advisorService", "advisorPpService", "generalService", InvestmentReportsController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/investment-reports.html';
        }
    }
    angular.module(Constants.APP).component("investmentReports", new InvestmentReports());
    
}